import { PatientPersonalInfo } from "patients-experience-client";
import { calculateAge } from "../../commonUtils";
import { formatDate } from "../../../../helper/dateFormatter";
import { ReactComponent as EditIcon } from "../../../../assets/img/EditPatientInfo.svg";
import { capitalizeInitial } from "../../../../helper/TextUtils";

interface Props {
    patientInfo?: PatientPersonalInfo;
    handleOffCanvasShow: (comp: string) => void;
    loading: boolean;
}

export const Personal = (props: Props) => {
    const patientInfo = props.patientInfo;
    console.log(patientInfo);

    return (<>
        <div className='d-flex align-items-center'>
            <h2 className='h4 m-0 me-auto'>Personal</h2>

            {patientInfo?.healthieId && <a className={`btn d-flex align-items-center py-1 px-1`} href={"https://secure.gethealthie.com/users/" + patientInfo?.healthieId} target="_blank" rel="noreferrer">
                <span className="d-inline-block lh-sm ms-2 border-primary border-bottom text-secondary">Healthie</span>
            </a>}
            {patientInfo?.zusId && <a className={`btn d-flex align-items-center py-1 px-1`} href={"https://app.zushealth.com/patients/" + patientInfo?.zusId} target="_blank" rel="noreferrer">
                <span className="d-inline-block lh-sm ms-2 border-primary border-bottom text-secondary">Zus</span>
            </a>}
            <a className={`btn d-flex align-items-center py-1 pe-4`} onClick={() => props.handleOffCanvasShow("editPersonalDetails")}>
                <EditIcon />
                <span className="d-inline-block lh-sm ms-2 border-primary border-bottom text-secondary">Edit</span>
            </a>
        </div>
        <hr />
        <div className="row g-2">
            <div className="col-12 col-md-6 col-lg-6">
                <div className="row">
                    <div className="col-12 col-md-6 col-lg-4 col-xl-4 mb-2">
                        <label className="form-label text-light mb-1 fs-14">
                            Wellinks ID
                        </label>
                        <p className="fw-medium mb-0 fs-14">
                            {
                                props.loading ? (<span className="placeholder-wave">
                                    <span className="placeholder w-80"></span>
                                </span>) : patientInfo?.wellinksId ? patientInfo?.wellinksId : '-'
                            }
                        </p>
                    </div>
                    <div className="col-12 col-md-6 col-lg-4 col-xl-4 mb-2">
                        <label
                            className="form-label text-light mb-1 fs-14"
                        >
                            First Name
                        </label>
                        <p className="fw-medium mb-0 fs-14">
                            {
                                props.loading ? (<span className="placeholder-wave">
                                    <span className="placeholder w-80"></span>
                                </span>) : patientInfo?.firstName ? capitalizeInitial(patientInfo?.firstName) : '-'
                            }
                        </p>
                    </div>
                    <div className="col-12 col-md-6 col-lg-4 col-xl-4 mb-2">
                        <label
                            className="form-label text-light mb-1 fs-14"
                        >
                            Last Name
                        </label>
                        <p className="fw-medium mb-0 fs-14">
                            {
                                props.loading ? (<span className="placeholder-wave">
                                    <span className="placeholder w-80"></span>
                                </span>) : patientInfo?.lastName ? capitalizeInitial(patientInfo?.lastName) : '-'
                            }
                        </p>
                    </div>
                </div>
            </div>
            <div className="col-12 col-md-6 col-lg-6">
                <div className="row">
                    <div className="col-12 col-md-12 col-lg-6 col-xl-6 mb-2">
                        <label
                            className="form-label text-light mb-1 fs-14"
                        >
                            Physical Address
                        </label>
                        <p className="fw-medium mb-0 fs-14">
                            {
                                props.loading ? (<span className="placeholder-wave">
                                    <span className="placeholder w-80"></span>
                                </span>) : ''
                            }
                            {
                                !props.loading ?
                                    (`${patientInfo?.physicalAddress}, ${patientInfo?.physicalAddressCity?.name}, ${patientInfo?.physicalAddressState?.name}, ${patientInfo?.physicalAddressZipcode}`) : ''
                            }
                        </p>
                    </div>
                    <div className="col-12 col-md-12 col-lg-6 col-xl-6 mb-2">
                        <label
                            className="form-label text-light mb-1 fs-14"
                        >
                            Time Zone
                        </label>
                        <p className="fw-medium mb-0 fs-14">
                            {
                                props.loading ? (<span className="placeholder-wave">
                                    <span className="placeholder w-80"></span>
                                </span>) :
                                    patientInfo?.timeZone ? patientInfo?.timeZone : '-'
                            }
                        </p>
                    </div>
                </div>
            </div>
            <div className="col-12 col-md-6 col-lg-6">
                <div className="row">
                    <div className="col-12 col-md-6 col-lg-4 col-xl-4 mb-2">
                        <label
                            className="form-label text-light mb-1 fs-14"
                        >
                            Preferred Name
                        </label>
                        <p className="fw-medium mb-0 fs-14">
                            {
                                props.loading ? (<span className="placeholder-wave">
                                    <span className="placeholder w-80"></span>
                                </span>) : patientInfo?.preferredName ? patientInfo?.preferredName : '-'
                            }
                        </p>
                    </div>
                    <div className="col-12 col-md-6 col-lg-4 col-xl-4 mb-2">
                        <label
                            className="form-label text-light mb-1 fs-14"
                        >
                            Gender
                        </label>
                        <p className="fw-medium mb-0 fs-14">
                            {
                                props.loading ? (<span className="placeholder-wave">
                                    <span className="placeholder w-80"></span>
                                </span>) : patientInfo?.genderInfo?.type ? patientInfo?.genderInfo?.type : '-'
                            }
                        </p>
                    </div>
                    <div className="col-12 col-md-6 col-lg-4 col-xl-4 mb-2">
                        <label
                            className="form-label text-light mb-1 fs-14"
                        >
                            Race
                        </label>
                        <p className="fw-medium mb-0 fs-14">
                            {
                                props.loading ? (<span className="placeholder-wave">
                                    <span className="placeholder w-80"></span>
                                </span>) : patientInfo?.raceInfo?.type ? patientInfo?.raceInfo?.type : '-'
                            }
                        </p>
                    </div>
                </div>
            </div>
            <div className="col-12 col-md-6 col-lg-6">
                <div className="row">
                    <div className="col-12 col-md-12 col-lg-6 col-xl-6 mb-2">
                        <label
                            className="form-label text-light mb-1 fs-14"
                        >
                            Mailing Address
                        </label>
                        <p className="fw-medium mb-0 fs-14">
                            {
                                props.loading ? (<span className="placeholder-wave">
                                    <span className="placeholder w-80"></span>
                                </span>) : ''
                            }
                            {
                                !props.loading ?
                                    (`${patientInfo?.mailingAddress}, ${patientInfo?.mailingAddressCity?.name}, ${patientInfo?.mailingAddressState?.name}, ${patientInfo?.mailingAddressZipcode}`) : ''
                            }
                        </p>
                    </div>
                    <div className="col-12 col-md-12 col-lg-6 col-xl-6 mb-2">
                        <label
                            className="form-label text-light mb-1 fs-14"
                        >
                            Spire HP ID
                        </label>
                        <p className="fw-medium mb-0 fs-14">
                            {
                                props.loading ? (<span className="placeholder-wave">
                                    <span className="placeholder w-80"></span>
                                </span>) : patientInfo?.spireHealthPortalId ? patientInfo?.spireHealthPortalId : '-'
                            }
                        </p>
                    </div>
                </div>
            </div>
            <div className="col-12 col-md-6 col-lg-6">
                <div className="row">
                    <div className="col-12 col-md-6 col-lg-4 col-xl-4 mb-2">
                        <label
                            className="form-label text-light mb-1 fs-14"
                        >
                            Ethnicity
                        </label>
                        <p className="fw-medium mb-0 fs-14">
                            {
                                props.loading ? (<span className="placeholder-wave">
                                    <span className="placeholder w-80"></span>
                                </span>) : patientInfo?.ethnicityInfo?.type ? patientInfo?.ethnicityInfo?.type : '-'
                            }
                        </p>
                    </div>
                    <div className="col-12 col-md-6 col-lg-4 col-xl-4 mb-2">
                        <label
                            className="form-label text-light mb-1 fs-14"
                        >
                            DOB
                        </label>
                        {/* @TODO: Convert DOB in proper format */}
                        <p className="fw-medium mb-0 fs-14">
                            {
                                props.loading ? (<span className="placeholder-wave">
                                    <span className="placeholder w-80"></span>
                                </span>) : patientInfo?.dob ? formatDate(patientInfo?.dob) : '-'
                            }
                        </p>
                    </div>
                    <div className="col-12 col-md-6 col-lg-4 col-xl-4 mb-2">
                        <label
                            className="form-label text-light mb-1 fs-14"
                        >
                            Age
                        </label>
                        <p className="fw-medium mb-0 fs-14">
                            {
                                props.loading ? (<span className="placeholder-wave">
                                    <span className="placeholder w-80"></span>
                                </span>) : patientInfo?.dob ? patientInfo?.dob && calculateAge(patientInfo?.dob.toLocaleString()) + ' Years' : '-'
                            }
                        </p>
                    </div>
                </div>
            </div>
            <div className="col-12 col-md-6 col-lg-6">
                <div className="row">
                    <div className="col-12 col-md-12 col-lg-6 col-xl-6 mb-2">
                        <label
                            className="form-label text-light mb-1 fs-14"
                        >
                            Country
                        </label>
                        <p className="fw-medium mb-0 fs-14">
                            {
                                props.loading ? (<span className="placeholder-wave">
                                    <span className="placeholder w-80"></span>
                                </span>) :
                                    patientInfo?.country?.name ? patientInfo?.country?.name : '-'
                            }
                        </p>
                    </div>
                    <div className="col-12 col-md-12 col-lg-6 col-xl-6 mb-2">

                    </div>
                </div>
            </div>
        </div>
    </>);
}